import { AgentType, createThread, fetchThreads } from './threads'
import type { GetProjectAgentThreadsResponse, ProjectAgentNewThreadResponse } from './threads'

export async function fetchMarketingThreads(projectId: number): Promise<GetProjectAgentThreadsResponse> {
  return fetchThreads(projectId, AgentType.MarketingAgent)
}

export async function createMarketingThread(projectId: number, title: string): Promise<ProjectAgentNewThreadResponse> {
  return createThread(projectId, title, AgentType.MarketingAgent)
}
